import {
    explodeParamsString,
    fixAEMRelURL,
    implodeParamsObject
} from 'Utils/urlUtils';
import StepsBlock from 'Components/StepsBlock/StepsBlock';
import {analyticsLabelBuilder} from './BusinessBloc.domain';
import {runDispatchEvent} from '../AnalyticsManager/AnalyticsManager.infra';

/**
 * @description This a module that allow you to navigate throught step.
 */
export default class BusinessBlock extends StepsBlock {
    /**
     * @description The param will be the wrapper of the module.
     * @param  {HTMLElement} domElement - Wrapper of the business block module.
     */
    constructor(domElement) {
        super(domElement);
        this.initListeners();
        this.mapSteps();
    }

    /**
     * @description  Set the value use in the model.
     * @param  {string} value - Value to be read from model.
     */
    addModel(value) {
        super.addModel(value);
    }

    /**
     * @description Set the listeners on all needed element.
     */
    initListeners() {
        [...this.domElement
            .querySelectorAll('[data-bb-value]')]
            .forEach(item => {
                item.addEventListener('click', this.handleBtnClick.bind(this));
            });

        [...this.domElement
            .querySelectorAll('[data-bb-btn-type="etapeSuivante"]')]
            .forEach(item => {
                item.addEventListener('click', this.handleGoToNext.bind(this));
            });

        [...this.domElement
            .querySelectorAll('[data-bb-btn-type="choixEtape"]')]
            .forEach(item => {
                item.addEventListener('click', this.handleGoToStep.bind(this));
            });

        [...this.domElement
            .querySelectorAll('[data-bb-btn-type="url"]')]
            .forEach(item => {
                item.addEventListener('click', this.handleGoToUrl.bind(this));
            });
        [...this.domElement
            .querySelectorAll('[data-bb-back-btn]')]
            .forEach(item => {
                item.addEventListener('click', this.handleBackBtnClick.bind(this));
            });
    }

    /**
     * @description Get the data attribute and set some
     * in tc_vars and set the key on the model.
     * @type {object}
     * @param {Event} event - Object to get the value from.
     */
    handleBtnClick(event) {
        const {dataset: {
            bbKey: key,
            bbValue: value,
            tcVarsKey
        }} = event.currentTarget;
        const currentStep = this.getActiveStep();

        const data = {[tcVarsKey]: value};

        const label = analyticsLabelBuilder({label: this.config.steps[currentStep], value});

        runDispatchEvent({clickType: 'N', label, data});

        this.addModel({[key]: value});
    }

    /**
     * @description Set the next step state.
     */
    handleGoToNext() {
        this.nextStep();
    }

    /**
     * @description Get the attribute from data-bb-go-step
     *  and set it as next step.
     * @param {Event} event - Element to get the value from.
     */
    handleGoToStep(event) {
        const {bbGoToStep: step} = event.currentTarget.dataset;
        this.goToStep(step);
    }

    /**
     * @description Get the info from the data attribute and.
     * @type {object}
     * @param {event} event - Object where we get the
     * attribute with information.
     */
    handleGoToUrl(event) {
        const {dataset: {
            bbUrl: url,
            bbUrlParams: contribParameters = '',
            bbUrlAnchor: anchor = null
        }} = event.currentTarget;

        const currentStep = this.getActiveStep();

        const data = {nom_etape: currentStep,
            num_etape: this.config.steps[currentStep],
            page_erreur: 0};

        const anchorFormat = anchor ? `#${anchor.replace('#', '')}` : '';
        runDispatchEvent({data, clickType: 'V', event: 'N'});
        this.prepareUrl(url, contribParameters, anchorFormat);
    }

    /**
     * @description Trigger the backStep methode when trigger.
     *
     */
    handleBackBtnClick() {
        this.backStep();
    }

    /**
     * @description Prepare the url with the
     * queryString and launch the redirect.
     * @param {string} url - Url that will be used for redirection.
     * @param {string} parameterString - QueryString to add to the url.
     * @param {string} anchor - Anchor to add to the url.
     * @param {boolean} [hasParametersToSend=true] - Trigger to add
     * the parameters to the url.
     */
    prepareUrl(url, parameterString, anchor, hasParametersToSend = true) {
        let fixedUrl = fixAEMRelURL(url);

        if(hasParametersToSend) {
            const [cleanUrl, urlParameters = ''] = fixedUrl.split('?');

            const parametersObject = {
                ...explodeParamsString(urlParameters),
                ...explodeParamsString(parameterString),
                ...this.getModel()
            };

            fixedUrl = cleanUrl + implodeParamsObject(parametersObject);
        }

        window.location.assign(fixedUrl + anchor);
    }
}
